import { createMutationFeedback } from "@eisox/server-state-feedback";

export const { MutationFeedback, mutationCache } = createMutationFeedback({ app: "webapp" });
